import { CustomerFavourites } from '../models';

export class FetchPromotionalCategory {
    static readonly type = '[PROMOTIONALCATEGORY] fetchPromotionalCategory';
    
    constructor(public payload?: string) {}
}


